import axios from "axios";
import { Capacitor } from "@capacitor/core";

// Lógica de selección de baseURL según entorno y plataforma:
// - Nativo producción (Android/iOS): va directo a Tailscale, sin pasar por nginx
// - Nativo desarrollo (Android/iOS): usa IP local del servidor de desarrollo
// - Web (navegador): baseURL vacía → nginx hace proxy con rutas relativas,
//   evitando CORS al quedar frontend y backend en el mismo origen
const getBaseURL = () => {
    const isNative = Capacitor.isNativePlatform();

    // Si es móvil (Android/iOS): URL absoluta directa al backend, sin pasar por nginx
    if (isNative) {
        return process.env.NODE_ENV === 'production'
            ? "https://tahuya.taile75a0b.ts.net"
            : "http://192.168.1.50:8000";
    }

    // Si es WEB (Navegador) → rutas relativas para que nginx haga proxy
    return "";
};

const API_URL = getBaseURL();

const api = axios.create({
    baseURL: API_URL,
    withCredentials: false,
});

// Interceptor de request: añade el token JWT al header Authorization si existe en localStorage
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Interceptor de response: maneja errores globales de autenticación y autorización
api.interceptors.response.use(
    // Respuestas exitosas se pasan sin modificar
    (response) => response,
    async (error) => {
        const { config, response, code } = error;

        // Lógica de Reintento Inteligente (para solventar el "segundo intento" en móvil)
        // Reintentamos si: no hay respuesta (error de red) o si hay timeout (ECONNABORTED)
        if (!response || code === 'ECONNABORTED') {
            config.__retryCount = config.__retryCount || 0;
            
            if (config.__retryCount < 1) { // Solo 1 reintento automático
                config.__retryCount += 1;
                console.log(`[API] Reintentando conexión (${config.__retryCount}/1) tras error: ${code || 'Network Error'}`);
                
                // Pequeña pausa exponencial/lineal (500ms)
                await new Promise(resolve => setTimeout(resolve, 500));
                
                // Relanzamos la petición con la misma configuración
                return api(config);
            }
        }

        const status = response?.status;
        const detail = response?.data?.detail;

        // 401: token inválido o expirado -> limpiar sesión y redirigir a login
        if (status === 401) {
            localStorage.removeItem("token");
            localStorage.removeItem("user_email");
            localStorage.removeItem("user_nombre");
            localStorage.removeItem("user_foto");
            localStorage.removeItem("user");
            window.location.href = "/login";
        }

        // 404 con detalle específico: el usuario fue expulsado de la sala -> volver al dashboard
        if (status === 404 && detail === "Usuario no pertenece a la sala") {
            window.location.href = "/compare";
        }

        return Promise.reject(error);
    }
);


export default api;
export { API_URL };
